import { render, staticRenderFns } from "./RegisterExtraUserTermsForm.vue?vue&type=template&id=457005be&scoped=true"
import script from "./RegisterExtraUserTermsForm.vue?vue&type=script&lang=js"
export * from "./RegisterExtraUserTermsForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterExtraUserTermsForm.vue?vue&type=style&index=0&id=457005be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457005be",
  null
  
)

export default component.exports